import React from 'react'

import "./market.css"
import { RiArrowRightSLine, RiArrowLeftSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
export default function Market() {

  const navigate = useNavigate()
  return (
    <div className='emas__home-market'>
        <div className='emas__home-market_container'>
            <h1>Our Electricity Market Services</h1>
            <p>We have combined a deep understanding of the energy sector with state-of-the-art modelling skills to create models of the electricity market that can be used for financial analysis, simulations and short to long-term forecasts.</p>
            <button onClick={ () => navigate('/Publications')}>Find out more</button>
        </div>
        <div className='emas__home-market_solutions'>
            <div>
              <RiArrowRightSLine className='svg2' size={30}/><p>Forecasting balancing prices</p><RiArrowLeftSLine className='svg1' size={30}/>
            </div>
            <div>
              <RiArrowRightSLine className='svg2' size={36}/><p>Describing current market dynamics</p><RiArrowLeftSLine className='svg1' size={30}/>
            </div>
            <div>
              <RiArrowRightSLine className='svg2' size={30}/><p>Supporting business plans</p><RiArrowLeftSLine className='svg1' size={30}/>
            </div>
            <div>
             <RiArrowRightSLine className='svg2' size={30}/><p>Forecasting carbon emissions</p><RiArrowLeftSLine className='svg1' size={30}/>
            </div>
            <div>
              <RiArrowRightSLine className='svg2' size={40}/><p>Detailed modelling of wind and solar output</p><RiArrowLeftSLine className='svg1' size={30}/>
            </div>
            <div>
              <RiArrowRightSLine className='svg2' size={30}/><p>Supporting market design</p><RiArrowLeftSLine className='svg1' size={30}/>
            </div>
            <div>
            <RiArrowRightSLine className='svg2' size={30}/><p>Estimating rates of return for network businesses</p><RiArrowLeftSLine className='svg1' size={30}/>
            </div>
        </div>
    </div>
  )
}
